import { Placeholder } from '@/tools/models/class-builder.models';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-class-subject-placeholder-create-modal'
})
export default class EdClassSubjectPlaceholderCreateModalComponent extends Vue {
  @Prop({}) readonly params: any;

  get placeholder(): Placeholder {
    return this.params.placeholder;
  }

  readonly defaultColor = '#000000';

  color = this.defaultColor;
  contentId: number = null;
  id = null;
  teacherId: number = null;
  title = EdInputModel('title',  '');
  titleChanged = false;

  emitOnCreatePlaceholder() {
    this.params.onCreatePlaceholder({
      color: this.color,
      contentId: this.contentId,
      id: this.id,
      teacherId: this.teacherId,
      title: this.title.value,
    });
    this.close();
  }

  get isFormInvalid() {
    return !this.color || !this.contentId || !this.teacherId || !this.title.value;
  }

  get subjects () {
    return this.params.subjects;
  }

  get teachers() {
    return this.params.teachers;
  }

  open() {
    if (this.placeholder) {
      this.color = this.placeholder.color;
      this.id = this.placeholder.id;
      this.contentId = this.placeholder?.contentId || null;
      this.teacherId = this.placeholder?.teacher?.id || null;
      this.title.value = this.placeholder.title;
      this.titleChanged = true;
    } else {
      this.color = this.defaultColor;
      this.id = null;
      this.contentId = null;
      this.teacherId = null;
      this.title.value = '';
      this.titleChanged = false;
    }
  }

  close() {
    this.params.onClose();
    this.$EdModal.closeModal();
  }

  onColorInput() {
    if (this.color.charAt(0) !== '#') {
      this.color = `#${this.color}`;
    }
  }

  onColorChanged() {
    if (this.color.length < 7) {
      this.color = this.defaultColor;
    }
  }

  onSubjectSelected(option) {
    this.contentId = option?.key;

    if (!this.titleChanged) {
      this.title.value = option?.value;
    }
  }

  onTeacherSelected(option) {
    this.teacherId = option?.key;
  }

  onTitleChanged() {
    this.titleChanged = !!this.title.value;
  }

  mounted() {
    this.open();
  }
}